// eslint-disable-next-line import/no-cycle
import { getApi, postApi } from '@/shared/api';

export default {
	namespaced: true,
	state: () => ({
		cities: null,
	}),
	mutations: {
		setLoanCities(state, val) {
			state.cities = val;
		},
	},
	actions: {
		// eslint-disable-next-line no-empty-pattern
		async createLoanApp({}, { sum, period }) {
			const response = await postApi('/k5/v1/loan-app/create', { sum, period });
			return response;
		},
		async getLoanCities() {
			const response = await postApi('/k5/v1/loan-app/cities');
			return response;
		},
		// eslint-disable-next-line no-unused-vars,camelcase
		async sendLoanRequest({ state }, { city_uid, monthly_income }) {
			const response = await postApi('/k5/v1/loan-app/edit', { city_uid, monthly_income });
			return response;
		},
		// eslint-disable-next-line no-unused-vars
		async getLoanAddress({ state }, { query }) {
			const response = await getApi(`api-k3/v2/address?query=${query}`);
			return response;
		},
		async loanComplete() {
			const response = await postApi('/k5/v1/loan-app/complete');
			return response;
		},
		async requestSign() {
			const response = await postApi('/k5/v1/loan-app/send-code-for-signing');
			return response;
		},
		// eslint-disable-next-line no-empty-pattern
		async acceptSign({ }, { code }) {
			const response = await postApi('/k5/v1/loan-app/sign', { code });
			return response;
		},
	},
	getters: {
		lastName(state) {
			return state.loanApp?.fields.find((field) => field.slug === 'last_name');
		},
		firstName(state) {
			return state.loanApp?.fields.find((field) => field.slug === 'first_name');
		},
		patronymic(state) {
			return state.loanApp?.fields.find((field) => field.slug === 'patronymic');
		},
		birthday(state) {
			return state.loanApp?.fields.find((field) => field.slug === 'birthday');
		},
		cities(state) {
			return state.cities
				?.map(({ uid, name }) => ({ value: uid, label: name }))
				.sort((a, b) => a.label.localeCompare(b.label));
		},
	},
};
